import { InfoOutlined } from "@mui/icons-material";
import { Chip as MuiChip, ChipProps as MuiChipProps, styled } from "@mui/material";

const StyledChip = styled(MuiChip)(() => {
  return {
    marginLeft: "1rem",
    padding: "0.25rem 0.5rem",
    fontWeight: "500",
  };
});

interface BetaPillProps extends MuiChipProps {
  withTooltip?: boolean | undefined;
  label?: string | undefined;
}

export const BetaPill: React.FC<BetaPillProps> = ({
  withTooltip,
  label = "Beta",
  color = "mutinexMagenta",
  ...props
}) => {
  return (
    <StyledChip
      color={color}
      size={"small"}
      label={label}
      {...props}
      {...(withTooltip && <InfoOutlined />)}
    />
  );
};

export default BetaPill;
